class HHVariantPicker extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.addEventListener('change', this.onVariantChange)
    this.initDisabledVariants()

    this.getProductData()
  }

  disconnnectedCallback() {
    this.removeEventListener('change', this.onVariantChange)
  }

  getProductData() {
    this.product = JSON.parse(
      document.querySelector('[data-product-data]')?.textContent || '{}'
    )
  }

  initDisabledVariants() {
    this.getVariantData().forEach((variant) => {
      if (!variant.available) {
        document
          .querySelector(
            `.js-variant-label[data-option-value='${variant.title}']`
          )
          ?.classList.add('c-subdued')
      } else {
        document
          .querySelector(
            `.js-variant-label[data-option-value='${variant.title}']`
          )
          ?.classList.add('bold')
      }
    })
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.triggerSizekick()
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (!newMedia) return
    const parent = newMedia.parentElement
    parent.prepend(newMedia)
    window.setTimeout(() => {
      parent.scroll(0, 0)
    })
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    const atcText = this.dataset.preOrder
      ? window.variantStrings.preOrder
      : this.dataset.finalSale
      ? window.variantStrings.addToCartFinalSale
      : window.variantStrings.addToCart

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
      addButton.setAttribute('style', 'display: none;')
      if (text) addButton.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButton.removeAttribute('style')
      addButton.textContent = atcText
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  async triggerSizekick() {
    this.sizekickTrigger = document.querySelector('hh-sizekick-trigger')
    if (!this.product || !this.sizekickTrigger) return
    await fetch('/cart.js')
      .then((response) => response.json())
      .then((response) => {
        const cartItems = response.items.filter(
          (item) => item.product_id === this.product?.id
        )
        const sizePosition = this.product.options.find(
          (option) => option.name === 'Size' || option.name === 'size'
        )?.position
        // check if cart has similar item but different size
        const similarItem = cartItems.find((item) => {
          return item.options_with_values.some((option) => {
            return (
              option.value !==
              this.currentVariant[`option${sizePosition}`]?.value
            )
          })
        })
        if (similarItem) {
          this.sizekickTrigger?.showTooltip()
        }
      })
      .catch((error) => {
        console.error('Error fetching cart:', error)
        return null
      })
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
